// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1bah1h6o{justify-content:center}\n._1bsbzwfg{width:2pc}\n._1e0c1txw{display:flex}\n._80omtlke{cursor:pointer}\n._bfhk1j28{background-color:transparent}\n._syaz1gjq{color:var(--ds-text-subtle,#44546f)}", ""]);
// Exports
module.exports = exports;
